import React, { Suspense } from "react";
import { BrowserRouter } from 'react-router-dom'
import { RoutesJSX } from './routing/Routes'
import { UserProvider } from '../context/provider/UserProvider'
import { SocketProvider } from '../context/provider/SocketProvider'
import CacheBuster from "react-cache-buster";
import packageJson from '../../package.json'

export const App = () => {
    const isProduction = process.env.NODE_ENV === 'production'
    return (
        <>
        <CacheBuster
            currentVersion={packageJson.version}
            isEnabled={isProduction}
        >
            <UserProvider>
                <SocketProvider>
                        <Suspense fallback={<h1>Cargando...</h1>}>
                            <BrowserRouter basename={process.env.REACT_APP_SUB_DIRECTORY}>
                                <RoutesJSX />
                            </BrowserRouter>
                        </Suspense>
                </SocketProvider>
            </UserProvider>
        </CacheBuster>
        </>
    )
}

export default App;
